<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="base-search">
    <div class="search-form-wrap">
      <el-form ref="searchForm" :inline="true" :model="model" class="el-search-from">
        <el-form-item v-for="item in formOptionsFilter" :key="item.prop" :prop="item.prop">
          <template v-if="item.label" #label>
            <slot :name="item.labelSlot">
              <span>{{ item.label }}</span>
            </slot>
          </template>
          <template v-if="item.prop && $scopedSlots[item.prop]">
            <slot :name="item.prop" :item="item" :model="model" :prop="item.prop" />
          </template>
          <component
            :is="item.component.name"
            v-else-if="item.component && item.component.name"
            v-model="model[item.prop]"
            v-bind="getAttrs(item)"
            v-on="getEvents(item)"
          >
            <template v-for="slot in item.component.slots" v-slot:[slot.name]>
              <div :key="slot.name" v-html="slot.content" />
            </template>
          </component>
        </el-form-item>
        <el-form-item>
          <el-button type="default" icon="el-icon-refresh" @click="handleReset" v-if="showReset">重置</el-button>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <slot />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { isFunction } from 'lodash'
export default {
  name: 'BaseSearch',
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
    showReset: {
      type: Boolean,
      default: false
    },
    formOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    formOptionsFilter() {
      return this.formOptions.filter(item => !item.hidden)
    }
  },
  watch: {},
  created() {},
  methods: {
    getAttrs(item) {
      const { component, prop } = item
      const { attrs } = component
      if (isFunction(attrs)) {
        return attrs(prop, this.model) || {}
      } else {
        return attrs
      }
    },
    getEvents(item) {
      const { component } = item
      const { listeners } = component
      return listeners || {}
    },
    handleSearch() {
      this.$emit('search', this.model)
    },
    handleReset() {
      this.$refs.searchForm.resetFields()
      this.$emit('search', this.model)
    },
  }
}
</script>

<style lang="scss" scoped>
.base-search {
  ::v-deep .el-form {
    .el-form-item__label {
      padding: 0;
      color: #303133;
      font-weight: normal;
    }
  }
}
</style>
